import React from 'react';
import PageLayout from '../components/PageLayout';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { faqs } from '../mock';
import { useAppSettings } from '../lib/i18n';
import { HelpCircle } from 'lucide-react';

export default function FaqPage() {
  const { t } = useAppSettings();
  return (
    <PageLayout>
      <section className="emi-wrap pt-8 pb-16">
        <div className="mb-8 flex items-start gap-4">
          <div className="h-12 w-12 rounded-xl bg-[#EAF5FE] text-[#0176D3] flex items-center justify-center shrink-0">
            <HelpCircle className="h-6 w-6" />
          </div>
          <div>
            <h1 className="text-3xl sm:text-4xl font-bold text-[#032D60] tracking-tight">{t('faq_title')}</h1>
            <p className="mt-2 text-sm sm:text-base text-slate-600 dark:text-slate-400 max-w-3xl">{t('faq_desc')}</p>
          </div>
        </div>

        <div className="rounded-2xl border border-slate-200 bg-white p-4 sm:p-8">
          <Accordion type="single" collapsible className="space-y-1">
            {faqs.map((f) => (
              <AccordionItem key={f.q} value={f.q} className="border-slate-100">
                <AccordionTrigger className="text-left text-sm sm:text-base font-semibold text-[#032D60] hover:text-[#0176D3] hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-slate-600 dark:text-slate-400 leading-relaxed pt-2">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-6 rounded-xl bg-[#EAF5FE] border border-[#B7E1FA] p-5 text-sm text-slate-700">
          Didn't find what you were looking for? Drop us a note on the <a href="/contact" className="text-[#0176D3] font-semibold hover:underline">Contact</a> page and we'll get back within 24 hours.
        </div>
      </section>
    </PageLayout>
  );
}
